import { useCallback } from 'react';

import Adjust from '@adjustcom/adjust-web-sdk';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { adjustLogger } from '../../adjust.logger';
import { hasOptedInToOneTrust } from '../../utils/one-trust';

// ─────────────────────────────────────────────────────────────────────────────

export const useTrackEvent = () => {
  const isAdjustEnabled = useFeatureFlag('permanent-adjust-enabled');

  return useCallback(
    (params: TrackEventParams) => {
      if (!isAdjustEnabled || !hasOptedInToOneTrust()) return;

      trackEvent(params);
    },
    [isAdjustEnabled],
  );
};

function trackEvent(params: TrackEventParams) {
  const { eventToken, properties, deduplicationId, revenue } = params;

  void Adjust.trackEvent({
    eventToken,
    callbackParams: Object.entries(properties).map(([key, value]) => ({ key, value })),
    ...(revenue !== undefined ? { revenue, currency: 'USD' } : {}),
    ...(deduplicationId !== undefined ? { deduplicationId } : {}),
  }).catch((error: unknown) => {
    adjustLogger.error('Web event tracking failed', error);
  });
}

// ─── Types ───────────────────────────────────────────────────────────────────

type TrackEventParams = {
  eventToken: string;
  properties: Record<string, string>;
  deduplicationId?: string;
  revenue?: number;
};
